<template>
  <page :title="$tc('magazine')+' / '+ $tc('subscription')">
    <div slot="page-header-right">
      <a :href="fullUrl" target="_blank" class="button">
        <b-icon icon="download"></b-icon>
        <span>{{ $tc('download.verb') }}</span>
      </a>
    </div>

    <div class="box">
      <filters @input="value => subscriptions.filter(value, true).load()"></filters>

      <hr />

      <b-table
        :data="subscriptions.data"
        :loading="subscriptions.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :current-page="subscriptions.current_page"
        :per-page="subscriptions.per_page"
        :total="subscriptions.total"
        @page-change="page => subscriptions.changePage(page)"
        backend-sorting
        @sort="(field, direction) => subscriptions.sort(field, direction)"
        :default-sort="['id', 'desc']"
        class="is-middle"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="#" sortable width="80">
            <router-link
              class="has-text-dark"
              :to="`/magazine/subscriptions/${props.row.id}`"
            >{{ props.row.id }}</router-link>
          </b-table-column>

          <b-table-column label="User">
            <router-link :to="`/users/${props.row.user.id}`">
              <span class="has-text-dark" v-if="props.row.user.email">{{ props.row.user.email }}</span>
              <span class="has-text-grey" v-else>User {{ props.row.user.id }}</span>
            </router-link>

            <div class="has-text-grey is-size-7">{{ props.row.user.name }}</div>
          </b-table-column>

          <b-table-column :label="$tc('subscriptions.plan')">
            <div>
              <a
                v-if="props.row.magazine"
                @click="subscriptions.filter({ magazine_id: props.row.magazine_id }).load()"
              >{{ props.row.magazine.name }}</a>

              <a v-else @click="subscriptions.filter({ only_xtra: true }).load()">
                {{ props.row.plan.name }}
              </a>
            </div>

            <div>
              <span
                v-if="props.row.plan"
                class="has-text-grey"
              >USD {{ props.row.plan.price }} / {{ props.row.plan.type.frequency }}</span>
            </div>
          </b-table-column>

          <b-table-column :label="$tc('support_ticket.status._name')">
            <span
              :class="{
                'tag is-success': props.row.status === 'active',
                'has-text-danger': props.row.status === 'expired',
                'tag': props.row.status === 'canceled',
              }"
            >{{ props.row.status }}</span>
          </b-table-column>

          <b-table-column label="Expiry Date" sortable field="expiry_date">
            <b-tooltip
              class="has-text-grey"
              :label="props.row.expiry_date"
            >{{ props.row.expiry_date | date }}</b-tooltip>

            <div class="has-text-warning is-size-7" v-if="props.row.on_grace_period">Grace Period</div>
            <div class="has-text-warning is-size-7" v-if="props.row.on_trial_period">Trial Period</div>
          </b-table-column>

          <b-table-column label="Auto Renew">
            <span class="has-text-weight-bold" v-if="props.row.auto_renew_status">Auto Renew</span>
            <span class="has-text-grey" v-else>Auto Disabled</span>
          </b-table-column>

          <b-table-column>
            <span v-if="props.row.is_test" class="tag is-warning">Test</span>
          </b-table-column>

          <b-table-column label="Payment">
            <span class="has-text-grey">
              {{ props.row.payment_gateway }}
            </span>

            <small class="has-text-grey">
            {{ props.row.original_transaction_id ? props.row.original_transaction_id : props.row.redeem_code }}
            </small>
          </b-table-column>

          <b-table-column label="Created At">
            <b-tooltip
              class="has-text-grey"
              :label="props.row.created_at"
            >{{ props.row.created_at | date }}</b-tooltip>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>{{$tc('Nothinghere')}}</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import Filters from "./Filters";
import querystring from "querystring";

export default {
  components: {
    Filters
  },

  data() {
    return {
      subscriptions: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/subscriptions"
      ).load()
    };
  },

  computed: {
    fullUrl() {
      let query = this.subscriptions.requestParams();

      query.format = "xlsx";

      return (
        this.subscriptions.resolveUrl() + "?" + querystring.stringify(query)
      );
    }
  }
};
</script>
